import { render, staticRenderFns } from "./WidgetDuplicates.vue?vue&type=template&id=00faf27e&scoped=true&"
import script from "./WidgetDuplicates.vue?vue&type=script&lang=js&"
export * from "./WidgetDuplicates.vue?vue&type=script&lang=js&"
import style0 from "./WidgetDuplicates.vue?vue&type=style&index=0&id=00faf27e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00faf27e",
  null
  
)

export default component.exports